import React from "react"
import Button from "components/Buttons/Button"
import { Box, Flex, HStack } from "@chakra-ui/react"
import CopyToClipboard from "components/elements/CopyToClipboard"

type Props = {
  url?: string
}

const ReceiptButton = ({ url }: Props) => {
  if (!url) {
    return null
  }

  return (
    <Flex justifyContent="flex-end">
      <Box as={HStack}>
        <CopyToClipboard text={url} variant="outline" size="sm">Copy Link</CopyToClipboard>
        <Button
          as="a"
          href={url}
          target="_blank"
          variant="outline"
          size="sm"
        >Receipt
        </Button>
      </Box>
    </Flex>
  )
}

export default ReceiptButton
